import { Route, Routes } from "react-router-dom";
import {
  MenuEditorPage,
  NewEditBeverage,
  NewEditKeg,
  OnTap,
  UserSettings,
  ManagementMenu,
  OnDeck,
  SysAdmin,
  Dashboard
} from "./pages";
import { AuthLayout } from "./components/Layouts";
import constants from "./utils/constants";

function App() {
  const paths = constants.ROUTE_PATHS;
  return (
    <div>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path={paths.ON_TAP} element={<OnTap />} />
          <Route path={paths.ON_DECK} element={<OnDeck />} />
          <Route path={paths.EDIT_KEG} element={<NewEditKeg />} />
          <Route path={paths.EDIT_BEVERAGE} element={<NewEditBeverage />} />
          <Route path={paths.MENU_EDITOR} element={<MenuEditorPage />} />
          <Route path={paths.USER_SETTINGS} element={<UserSettings />} />
          <Route path={paths.MANAGEMENT} element={<ManagementMenu />} />

          <Route path={paths.SYS_ADMIN} element={<SysAdmin />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
